{
    "SortAsc1Label": "1e Oplopend",
    "SortDsc1Label": "1e Aflopend",
    "SortAsc2Label": "2e Oplopend",
    "SortDsc2Label": "2e aflopend",
    "SortAsc3Label": "3e Oplopend",
    "SortDsc3Label": "3e aflopend",
    "SortNoneLabel": "[Niet gesorteerd op]",
    "SortAsc1Tooltip": "Sorteer rapportrijen voornamelijk oplopend op de geselecteerde statistiek\/het geselecteerde veld.",
    "SortDsc1Tooltip": "Sorteer rapportrijen voornamelijk aflopend op de geselecteerde statistiek\/het geselecteerde veld.",
    "SortAsc2Tooltip": "Sorteer secundair oplopend op de geselecteerde statistiek\/het geselecteerde veld.",
    "SortDsc2Tooltip": "Sorteer secundair aflopend op de geselecteerde statistiek\/het geselecteerde veld.",
    "SortAsc3Tooltip": "Sorteer rapportrijen 3e oplopend op de geselecteerde statistiek\/het geselecteerde veld.",
    "SortDsc3Tooltip": "Sorteer rapportrijen 3e aflopend op de geselecteerde statistiek\/het geselecteerde veld.",
    "SortNoneTooltip": "Sorteer rapportrijen niet op de geselecteerde statistiek\/het geselecteerde veld.",
    "NAME": "SortList"
}